import { useTranslation } from "react-i18next";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

export interface SelectProps {
  label: string;
  currrentValue: string;
  showOptions: boolean;
  isSelected: boolean;
  onClickOnDropDown: () => void;
  onClickOnOption: (value: string) => void;
  options: string[];
  validation?: JSX.Element;
  validationTouched?: boolean | undefined;
  validationErrors?: string | undefined;
}
function SelectFormsSmaller({ label, options, ...props }: SelectProps) {
  const { i18n } = useTranslation();
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col gap-2"
    >
      <div className="grid grid-cols-1 gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {label}
        </label>
        <div className="relative">
          <div
            className={`
            ${
              props.validationTouched && props.validationErrors
                ? "border-secondary-50 focus:border-secondary-50"
                : "border-zinc400 focus:border-mint-500"
            } w-[204.5px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] px-4 py-[17px] rounded-[18px] border focus:outline-none caret-mint-500 focus:shadow-none appearance-none ${
              i18n.language === "ar" ? "text-right" : "text-left"
            } ${
              props.isSelected ? "text-zinc900" : "text-zinc300"
            } text-lg font-arMedium leading-7 cursor-pointer`}
            onClick={props.onClickOnDropDown}
          >
            {props.currrentValue}
          </div>
          {props.showOptions && (
            <div
              dir="ltr"
              className="absolute top-[70px] w-[280px] h-fit max-h-64 bg-slate-50 rounded z-40 mobile:w-[250px] mobile:h-[216px] tablet:w-[260px] shadow-md py-2 px-3.5 overflow-y-auto"
            >
              <div
                dir={i18n.language === "ar" ? "rtl" : "ltr"}
                className="flex flex-col"
              >
                {options.map((item) => (
                  <>
                    <p
                      onClick={() => props.onClickOnOption(item)}
                      className="flex flex-col justify-center font-ar text-M3 text-base w-full h-10 hover:bg-slate-200 hover:rounded pr-4 cursor-pointer"
                    >
                      {item}
                    </p>
                    <div className="bg-slate-300 w-full h-[0.3px]"></div>
                  </>
                ))}
              </div>
            </div>
          )}
          {props.showOptions ? (
            <FiChevronUp
              className={`${
                i18n.language === "ar" ? "left-[14px]" : "right-[14px]"
              } absolute top-[18px] text-zinc900`}
              size={24}
            />
          ) : (
            <FiChevronDown
              className={`${
                i18n.language === "ar" ? "left-[14px]" : "right-[14px]"
              } absolute top-[18px] text-zinc300`}
              size={24}
            />
          )}
        </div>
      </div>
      {props.validationTouched && props.validationErrors && props.validation}
    </div>
  );
}

export default SelectFormsSmaller;
